var time = 1000;
var _handicapTypeArray = ["/-", "+/-", "/*", "让/受让"];
var _handicapType = 1;
var _handicapAccept = "-";
var _handicapGive = "";
var _ouTrimEndZero = false;
var oldData = null,
  newDatas = [];

  var GoalCn = [
    "0",
    "0/{0}0.5",
    "{0}0.5",
    "{0}0.5/1",
    "{0}1",
    "{0}1/1.5",
    "{0}1.5",
    "{0}1.5/2",
    "{0}2",
    "{0}2/2.5",
    "{0}2.5",
    "{0}2.5/3",
    "{0}3",
    "{0}3/3.5",
    "{0}3.5",
    "{0}3.5/4",
    "{0}4",
    "{0}4/4.5",
    "{0}4.5",
    "{0}4.5/5",
    "{0}5",
    "{0}5/5.5",
    "{0}5.5",
    "{0}5.5/6",
    "{0}6",
    "{0}6/6.5",
    "{0}6.5",
    "{0}6.5/7",
    "{0}7",
    "{0}7/7.5",
    "{0}7.5",
    "{0}7.5/8",
    "{0}8",
    "{0}8/8.5",
    "{0}8.5",
    "{0}8.5/9",
    "{0}9",
    "{0}9/9.5",
    "{0}9.5",
    "{0}9.5/10",
    "{0}10",
    "{0}10/10.5",
    "{0}10.5",
    "{0}10.5/11",
    "{0}11",
    "{0}11/11.5",
    "{0}11.5",
    "{0}11.5/12",
    "{0}12",
    "{0}12/12.5",
    "{0}12.5",
    "{0}12.5/13",
    "{0}13",
    "{0}13/13.5",
    "{0}13.5",
    "{0}13.5/14",
    "{0}14",
  ];
  var GoalCnOU = [
  "0",
  "0/0.5",
  "0.5",
  "0.5/1",
  "1",
  "1/1.5",
  "1.5",
  "1.5/2",
  "2",
  "2/2.5",
  "2.5",
  "2.5/3",
  "3",
  "3/3.5",
  "3.5",
  "3.5/4",
  "4",
  "4/4.5",
  "4.5",
  "4.5/5",
  "5",
  "5/5.5",
  "5.5",
  "5.5/6",
  "6",
  "6/6.5",
  "6.5",
  "6.5/7",
  "7",
  "7/7.5",
  "7.5",
  "7.5/8",
  "8",
  "8/8.5",
  "8.5",
  "8.5/9",
  "9",
  "9/9.5",
  "9.5",
  "9.5/10",
  "10",
  "10/10.5",
  "10.5",
  "10.5/11",
  "11",
  "11/11.5",
  "11.5",
  "11.5/12",
  "12",
  "12/12.5",
  "12.5",
  "12.5/13",
  "13",
  "13/13.5",
  "13.5",
  "13.5/14",
  "14",
];

function getCookie(name) {
  var cname = name + "=";
  var dc = document.cookie;
  if (dc.length > 0) {
    let begin = dc.indexOf(cname);
    if (begin != -1) {
      begin += cnamodd.length;
      end = dc.indexOf(";", begin);
      if (end == -1) end = dc.length;
      return dc.substring(begin, end);
    }
  }
  return null;
}

function GetHandicapType() {
  var detault = 1;
  var handicapType = getCookie("Handicap_Type");
  if (handicapType) detault = parseInt(handicapType);
  return detault;
}

function initHandicap() {
  _handicapType = GetHandicapType();
  if (_handicapType <= _handicapTypeArray.length) {
    _handicapGive = _handicapTypeArray[_handicapType - 1].split('/')[0];
    _handicapAccept = _handicapTypeArray[_handicapType - 1].split('/')[1];
  }
}

// initHandicap();

function Goal2GoalCn(goal) { //handicap conversion
  if ((!goal && goal != "0") || isNaN(goal))
      return "";
  else {
      if (goal > 10) return _handicapGive + Math.abs(goal);
      if (goal < -10) return _handicapAccept + Math.abs(goal);
      var i = Math.abs(parseInt(goal * 4));
      if (goal >= 0) return GoalCn[i].replace("{0}", _handicapGive);
      else return GoalCn[i].replace("{0}", _handicapAccept);
  }
}

function Goal2GoalCn2(goal) {
  return Goal2GoalCn(goal);
}

function getClass(key, t) {
  try {
    if (
      typeof oldData &&
      "-" !== oldData[key][t] &&
      "-" !== newDatas[key][t] &&
      newDatas[key][t] !== oldData[key][t]
    ) {
      return newDatas[key][t] > oldData[key][t]
        ? "as-odds__text-up"
        : "as-odds__text-down";
    }
  } catch (error) {}

  return "";
}

function getColumnData(key, t) {
  try {
    if (
      typeof newDatas && newDatas[key] || newDatas[key][t] &&
      newDatas[key][t] !== newDatas[key][t]
    ) {
      return newDatas[key][t];
    }
  } catch (error) {}

  return "-";
}

function getValueBySportType(sportType, val) {
  if(!val) {
    return [];
  }
  if(['tennis', 'badminton', 'volleyball'].includes(sportType)) {
    return [val[0], '',  val[1], val[2], val[3]];
  } else {
    return val;
  }
}

function getData(sportType, odd, company) {
  let data = {};
  if(!odd) {
    return data;
  }

  const newData = odd.find(item => item.company_id == company);
  if(!newData) {
    return data;
  }

  ['asia', 'eu', 'bs', 'cr'].forEach(type => {
    const oddRegion = newData[type];
    data[`${type}_early`] = oddRegion ? getValueBySportType(sportType, oddRegion.early) : [];
    data[`${type}_live`] = oddRegion ? getValueBySportType(sportType, oddRegion.live) : [];
    data[`${type}_run`] = oddRegion ? getValueBySportType(sportType, oddRegion.run) : [];
    data[type + '_is_close'] = !oddRegion ? true : false;
  });

  return data;
}

export const getOdds = (sportType, odd, oddOld, company) => {
  initHandicap();
  newDatas = getData(sportType, odd, company);
  oldData = getData(sportType, oddOld, company);

  const data = {};
  ['asia', 'eu', 'bs', 'cr'].forEach(type => {
    let typeObj = `${type}_early`;
    data[`${type}_early_1`] = newDatas[`${type}_is_close`] ? "-" : getColumnData(typeObj, 2) || "-";
    data[`${type}_class_early_1`] = newDatas[`${type}_is_close`] || getClass(typeObj, 2);
    if(type === 'eu' || type === 'cr') {
      data[`${type}_early_2`] = newDatas[`${type}_is_close`] ? "-" : getColumnData(typeObj, 3) || "-";
    } else {
      data[`${type}_early_2`] = newDatas[`${type}_is_close`] ? "-" : Goal2GoalCn(getColumnData(typeObj, 3)) || "-";
    }
    data[`${type}_class_early_2`] = newDatas[`${type}_is_close`] || getClass(typeObj, 3);
    data[`${type}_early_3`] = newDatas[`${type}_is_close`] ? "-" : getColumnData(typeObj, 4) || "-";
    data[`${type}_class_early_3`] = newDatas[`${type}_is_close`] || getClass(typeObj, 4);

    typeObj = `${type}_live`;
    data[`${type}_live_1`] = newDatas[`${type}_is_close`] ? "-" : getColumnData(typeObj, 2) || "-";
    data[`${type}_class_live_1`] = newDatas[`${type}_is_close`] || getClass(typeObj, 2);
    if(type === 'eu' || type === 'cr') {
      data[`${type}_live_2`] = newDatas[`${type}_is_close`] ? "-" : getColumnData(typeObj, 3) || "-";
    } else {
      data[`${type}_live_2`] = newDatas[`${type}_is_close`] ? "-" : Goal2GoalCn(getColumnData(typeObj, 3)) || "-";
    }
    data[`${type}_class_live_2`] = newDatas[`${type}_is_close`] || getClass(typeObj, 3);
    data[`${type}_live_3`] = newDatas[`${type}_is_close`] ? "-" : getColumnData(typeObj, 4) || "-";
    data[`${type}_class_live_3`] = newDatas[`${type}_is_close`] || getClass(typeObj, 4);

    typeObj = `${type}_run`;
    data[`${type}_run_1`] = newDatas[`${type}_is_close`] ? "-" : getColumnData(typeObj, 2) || "-";
    data[`${type}_run_class_1`] = newDatas[`${type}_is_close`] || getClass(typeObj, 2);
    if(type === 'eu' || type === 'cr') {
      data[`${type}_run_2`] = newDatas[`${type}_is_close`] ? "-" : getColumnData(typeObj, 3) || "-";
    } else {
      data[`${type}_run_2`] = newDatas[`${type}_is_close`] ? "-" : Goal2GoalCn(getColumnData(typeObj, 3)) || "-";
    }
    data[`${type}_run_class_2`] = newDatas[`${type}_is_close`] || getClass(typeObj, 3);
    data[`${type}_run_3`] = newDatas[`${type}_is_close`] ? "-" : getColumnData(typeObj, 4) || "-";
    data[`${type}_run_class_3`] = newDatas[`${type}_is_close`] || getClass(typeObj, 4);
  });

  return data;
};

function getDataEsports(sportType, odd, company) {
  let data = {};
  if(!odd) {
    return data;
  }

  const newData = odd.find(item => item.company_id == company);
  if(!newData) {
    return data;
  }

  ['match', 'game'].forEach(type => {
    const oddRegion = newData[type === 'match' ? '101' : '1001'];
    data[`${type}_early`] = oddRegion ? getValueBySportType(sportType, oddRegion.early) : [];
    data[`${type}_run`] = oddRegion ? getValueBySportType(sportType, oddRegion.run) : [];
    data[type + '_early_is_close'] = data[`${type}_early`] && data[`${type}_early`].length > 4 && data[`${type}_early`][4] === 1 ? true : false;
    data[type + '_run_is_close'] = data[`${type}_run`] && data[`${type}_run`].length > 4 && data[`${type}_run`][4] === 1 ? true : false;
  });

  return data;
}
export const getOddsEsports = (sportType, odd, oddOld, company) => {
  initHandicap();
  newDatas = getDataEsports(sportType, odd, company);
  oldData = getDataEsports(sportType, oddOld, company);

  const data = {};
  ['match', 'game'].forEach(type => {
    let typeObj = `${type}_early`;
    data[`${type}_early_home`] = newDatas[`${type}_early_is_close`] ? "-" : getColumnData(typeObj, 1) || "-";
    data[`${type}_class_early_home`] = newDatas[`${type}_early_is_close`] || getClass(typeObj, 1);
    data[`${type}_early_handicap`] = newDatas[`${type}_early_is_close`] ? "-" : getColumnData(typeObj, 2) || "-";
    data[`${type}_class_early_handicap`] = newDatas[`${type}_early_is_close`] || getClass(typeObj, 2);
    data[`${type}_early_away`] = newDatas[`${type}_early_is_close`] ? "-" : getColumnData(typeObj, 3) || "-";
    data[`${type}_class_early_away`] = newDatas[`${type}_early_is_close`] || getClass(typeObj, 3);

    typeObj = `${type}_run`;
    data[`${type}_run_home`] = newDatas[`${type}_run_is_close`] ? "-" : getColumnData(typeObj, 1) || "-";
    data[`${type}_class_run_home`] = newDatas[`${type}_run_is_close`] || getClass(typeObj, 1);
    data[`${type}_run_handicap`] = newDatas[`${type}_run_is_close`] ? "-" : getColumnData(typeObj, 2) || "-";
    data[`${type}_class_run_handicap`] = newDatas[`${type}_run_is_close`] || getClass(typeObj, 2);
    data[`${type}_run_away`] = newDatas[`${type}_run_is_close`] ? "-" : getColumnData(typeObj, 3) || "-";
    data[`${type}_class_run_away`] = newDatas[`${type}_run_is_close`] || getClass(typeObj, 3);
  });

  return data;
}